// extracted by css-extract-rspack-plugin
export default {"container":"headerCustomLinksDesktop-module__container","separator":"headerCustomLinksDesktop-module__separator"};